import React, { useState, useRef } from 'react';
import {
  Box,
  Typography,
  Avatar,
  TextField,
  IconButton,
  MenuItem,
  Paper,
  Radio,
  InputAdornment,
  Popper,
  ClickAwayListener
} from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CloseBlackIcon } from '../icons';

const projects = [
  { id: 1, name: 'Project Quantum', image: '', code: 'PQ', description: 'Description 1' },
  { id: 2, name: 'Digital Marketing', image: '', code: 'DM', description: 'Description 2' },
  { id: 3, name: 'SkyGrid', image: '', code: 'SG', description: 'Description 3' },
  { id: 4, name: 'Video Editor', image: '', code: 'VE', description: 'Description 4' },
];

const getInitials = (name) => {
  const words = name.split(' ');
  return words.length > 1
    ? words[0][0].toUpperCase() + words[1][0].toUpperCase()
    : name.slice(0, 2).toUpperCase();
};

const MoveActivities = ({ selectedProject, setSelectedProject, reason, setReason }) => {
  const [search, setSearch] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const anchorRef = useRef(null);

  const filteredProjects = projects.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleProjectSelect = (project) => {
    setSelectedProject(project);
    setDropdownOpen(false);
  };

  const handleRemove = () => {
    setSelectedProject(null);
  };

  // Dummy user and project details (can be passed via props)
  const user = {
    name: 'Salona Mishra',
    image: '/assets/images/users/user1.png',
  };

  const project = {
    name: 'Project Quantum',
    image: '',
    description: 'Worked Desk 1',
  };

  return (
    <Box bgcolor="#fff">
      {/* User Info */}
      <Paper sx={{ p: 2, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'start', border: '1px solid #0076FE', boxShadow: 'none' }}>
        <Box>
          <Typography fontWeight="400" sx={{ fontSize: '12px', color: '#606060' }}>Member</Typography>
          <Box display="flex" alignItems="center" gap={1} mt={1}>
            <Avatar src={user.image} sx={{ fontSize: '14px', background: '#0067C7' }}>
              {!user.image && getInitials(user.name)}
            </Avatar>
            <Box>
              <Typography fontWeight="bold" sx={{ fontSize: '14px', color: '#373737' }}>{user.name}</Typography>
              <Typography variant="body2" sx={{ fontSize: '12px', color: '#8C8C8C' }}>
                Project Manager
              </Typography>
            </Box>
          </Box>
          <Box mt={2}>
            <Typography variant="body2" sx={{ fontSize: '14px', color: '#373737', fontWeight: '600' }}>
              <span className="d-block fw-normal" style={{ fontSize: '12px', color: '#8C8C8C' }}>Selected time:</span> 0:09:40 across 1 project.
            </Typography>
          </Box>
        </Box>
        <Box>
          <Typography fontWeight="400" sx={{ fontSize: '12px', color: '#606060' }}>Project</Typography>
          <Box display="flex" alignItems="center" gap={1} mt={1}>
            <Avatar src={project.image} sx={{ fontSize: '14px', background: '#0067C7' }}>
              {!project.image && getInitials(project.name)}
            </Avatar>
            <Box>
              <Typography fontWeight='bold' sx={{ fontSize: '14px', color: '#373737' }}>{project.name}</Typography>
              <Typography variant="body2" sx={{ fontSize: '12px', color: '#8C8C8C' }}>{project.description}</Typography>
            </Box>
          </Box>
        </Box>
      </Paper>

      {/* Project Dropdown */}
      <Box mb={2}>
        <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
          <div>
            <Typography fontWeight={500} mb={1} sx={{ fontSize: '14px', fontWeight: '600' }}>Project*</Typography>
            <TextField
              fullWidth
              placeholder="Select Project"
              inputRef={anchorRef}
              value={selectedProject?.name || ''}
              onClick={() => setDropdownOpen(!dropdownOpen)}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <ArrowDropDownIcon />
                  </InputAdornment>
                ),
              }}
            />

            <Popper
              open={dropdownOpen}
              anchorEl={anchorRef.current}
              style={{ zIndex: 1300, width: anchorRef.current?.offsetWidth }}
            >
              <Paper sx={{ mt: 1, maxHeight: 250, overflowY: 'auto' }}>
                <Box p={1} sx={{ position: 'sticky', top: '0', zIndex: '9', background:'#fff', }}>
                  <TextField
                    placeholder="Search Project"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    fullWidth
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                {filteredProjects.map((project) => (
                  <MenuItem key={project.id} onClick={() => handleProjectSelect(project)}>
                    <Radio checked={selectedProject?.id === project.id} value={project.id} />
                    <Avatar sx={{ width: 32, height: 32, mr: 2, fontSize: '14px', background: '#0067C7' }} src={project.image}>
                      {!project.image && getInitials(project.name)}
                    </Avatar>
                    <Typography>{project.name}</Typography>
                  </MenuItem>
                ))}
              </Paper>
            </Popper>
          </div>
        </ClickAwayListener>
      </Box>

      {/* Selected project display */}
      {selectedProject && (
        <Box
          mb={2}
          p={1}
          border="1px solid #DFDFDF"
          borderRadius={100}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: '#F6F6F6',
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Avatar src={selectedProject.image} sx={{ fontSize: '14px', background: '#0067C7' }}>
              {!selectedProject.image && getInitials(selectedProject.name)}
            </Avatar>
            <Box>
              <Typography sx={{ color: '#373737', fontSize: '14px', fontWeight: '600' }}>{selectedProject.name}</Typography>
              <Typography sx={{ color: '#9095A1', fontSize: '10px' }}>
                {selectedProject.description}
              </Typography>
            </Box>
          </Box>
          <IconButton onClick={handleRemove}>
            <CloseBlackIcon />
          </IconButton>
        </Box>
      )}

      {/* Reason Field */}
      <Typography fontWeight={500} mb={1} sx={{ fontSize: '14px', fontWeight: '600' }}>Reason*</Typography>
      <TextField
        placeholder="What were you working on ?"
        fullWidth
        multiline
        rows={3}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        sx={{ mb: 3, fontSize: '14px' }}
      />
    </Box>
  );
};

export default MoveActivities;
